@if (walletData | async; as data) {
  <div class="bp-modal mod-lg">
    <bp-modal-header [cssStyle]="'mod-details'" [title]="'button_deposit' | translate: [getTradableSymbol()]">
      <a right (click)="close()" class="large-weight" (keydown.enter)="close()" [tabIndex]="0">
        {{ "close" | translate }}
      </a>
    </bp-modal-header>
    <div class="bp-modal-body-section">
      @if (coin.isDepositActive()) {
        @if (data?.currentAddress.getAddress()) {
          @if (!data?.currentAddress.isDisabled()) {
            @if (!showLoadingNewAddress) {
              <crypto-qr
                right
                [networkName]="currentNetwork"
                [address_info]="getAddressInfo()"
                [cryptocoinIcon]="cryptocoinIcon"
                [networkIcon]="networkIcon"
                [address]="data?.currentAddress"
                [coin]="coin"
                [warning]="warning">
              </crypto-qr>
              @if (canCreateMoreAddress()) {
                <div class="wallet-details-border">
                  <a
                    class="address-link-center"
                    [ngClass]="{ unclickable: block }"
                    (click)="createNewAddress(data?.wallet)">
                    <span class="bpi__icon-plus-circle mr-5"></span>
                    {{ "create_new_wallet_address" | translate }}
                  </a>
                </div>
              }
              @if (showHistorical) {
                <div class="address-link-center-historical-header">
                  {{ "header_historical_addresses" | translate }}
                </div>
                @for (address of data?.otherAddresses; track address) {
                  <crypto-wallet-address
                    [address]="address"
                  [coinSymbol]="getTradableSymbol()"></crypto-wallet-address>
                }
              } @else {
                @if (showOtherWalletAddresses(data)) {
                  <a
                    class="address-link-center-historical"
                    (click)="showHistorical = true"
                    >
                    {{ "other_wallet_addresses" | translate }}
                  </a>
                }
              }
            } @else {
              <empty [headline]="'please_wait_loading' | translate"></empty>
            }
          }
        } @else {
          @if (coin?.isDepositActive()) {
            @if (isReasonForNoNewAddress('erc20')) {
              <div>
                <empty [headline]="'another_existing_erc20_address' | translate"></empty>
                <div class="bp-modal-body-section-default-button">
                  @if (!data?.wallet?.isDefault()) {
                    <a
                      class="btn btn-primary mod-default"
                      (click)="openWalletDetails()">
                      {{ "default_crypto_wallet" | translate: [getTradableSymbol()] }}
                    </a>
                  }
                </div>
              </div>
            } @else {
              <empty
                [headline]="'wallet_address_no_wallet_address_textheader' | translate"
                [loading]="showLoadingNewAddress"
                text="wallet_address_no_wallet_address_text"
                buttonText="create_new_wallet_address"
                (buttonClick)="createNewAddress(data?.wallet)">
              </empty>
            }
          }
          @if (isMaxWalletNumberReached('miota')) {
            <div>
              <empty [headline]="'maximum_number_miota_reached' | translate"></empty>
            </div>
          }
        }
      } @else {
        <div class="deposit-disabled-container">
          <h2>{{ "deposit_disabled" | translate }}</h2>
          <p>{{ "unavailable_under_maintenance" | translate }}</p>
          <bp-info full>{{ "deposit_disabled_status_info" | translate }}</bp-info>
          <a class="twitter-handle" href="https://status.bitpanda.com/" target="_blank">
            {{ "status_page_maintenance_link" | translate }}
          </a>
        </div>
      }
    </div>
  </div>
}
